/**
 * Picks v2 or v1 of the Session edit page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SessionsAddEditPage   from './SessionsAddEditPage';
import SessionsAddEditPageV2 from './SessionsAddEditPageV2';

export default function SessionsAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SessionsAddEditPageV2 : SessionsAddEditPage;
  return <Component {...props} />;
}
